import { useEffect, useMemo } from 'react';
import { Layer, Source } from 'react-map-gl';
import styled from 'styled-components';
import usePolygons from '../../hooks/Polygons';
import { useDispatch, useSelector } from 'react-redux';
import { ResultsType } from '../../types';
import { useRouter } from 'next/router';
import { setSelectedCompound } from '../../../../redux/slices/mapSlice';

const MapPolygons = () => {
  const polygonsLocations = usePolygons();
  const resultsType = useSelector((state: any) => state.map.resultsType);
  const resultType = resultsType == 'areas' ? 'area' : 'compound';
  const filters = useSelector((state: any) => state.map.filters);
  const dispatch = useDispatch();
  const { query } = useRouter();

  useEffect(() => {
    return () => {
      if (query?.view != 'map') {
        dispatch(setSelectedCompound(null));
      }
    };
  }, []);
  const Polygons = useMemo(() => {
    return polygonsLocations?.features?.map((feature, index) => (
      <div key={feature.properties?.id || index}>
        <Source
          id={`source-${feature.properties?.id || index}`}
          type="geojson"
          data={{
            type: 'FeatureCollection',
            features: [feature]
          }}
        >
          <Layer
            id={`${resultType}-fill-${feature.properties?.id || index}`}
            type="fill"
            paint={
              resultsType == ResultsType.AREAS
                ? {
                    'fill-color': [
                      'case',
                      ['==', ['get', 'isFiltered'], true],
                      'rgba(1, 93, 154, 0.281)',
                      Object.keys(filters).length == 0
                        ? 'rgba(1, 93, 154, 0.281)'
                        : 'rgba(69, 69, 69, 0.449)'
                    ]
                  }
                : {
                    'fill-color': 'transparent'
                  }
            }
          />

          <Layer
            id={`${resultType}-line-${feature.properties?.id || index}`}
            type="line"
            paint={
              resultsType == ResultsType.COMPOUNDS
                ? Object.keys(filters).length == 0
                  ? {
                      'line-color': [
                        'case',
                        ['==', ['get', 'isSelected'], true],
                        '#FF5E00',
                        '#015C9A'
                      ],
                      'line-opacity': 1,
                      'line-width': 2
                    }
                  : {
                      'line-color': [
                        'case',
                        ['==', ['get', 'isSelected'], true],
                        '#FF5E00',
                        ['==', ['get', 'isFiltered'], true],
                        '#015C9A',
                        '#5B6573'
                      ],
                      'line-opacity': 1,
                      'line-width': 2
                    }
                : resultsType == ResultsType.AREAS &&
                    Object.keys(filters).length == 0
                  ? {
                      'line-color': '#015C9A',
                      'line-opacity': 1,
                      'line-width': 2
                    }
                  : {
                      'line-color': [
                        'case',
                        ['==', ['get', 'isFiltered'], true],
                        '#015C9A',
                        '#626262'
                      ],
                      'line-opacity': 1,
                      'line-width': 2
                    }
            }
          />
        </Source>
      </div>
    ));
  }, [polygonsLocations]);

  return <Container>{Polygons}</Container>;
};

const Container = styled.div``;

export default MapPolygons;
